import React, { FC } from 'react';
import {
  LinkItem,
  LinkItemWrapper,
  LinkListWrapper,
  ListWrapper,
  Title,
} from './styles';

const LinkList: FC<LinkListProps> = ({ title = 'Contato', linkList = [] }) => (
  <LinkListWrapper>
    <Title>{title}</Title>
    <ListWrapper>
      {linkList.map(({ href, label }) => (
        <LinkItemWrapper key={href + label}>
          <LinkItem href={href}>{label}</LinkItem>
        </LinkItemWrapper>
      ))}
    </ListWrapper>
  </LinkListWrapper>
);

export default LinkList;
